import { useState } from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AdminSidebar, type AdminSection, menuItems } from "./AdminSidebar";
import { AirportsSection } from "./sections/AirportsSection";
import { ZonesSection } from "./sections/ZonesSection";
import { ServiceTypesSection } from "./sections/ServiceTypesSection";
import { VehiclesSection } from "./sections/VehiclesSection";
import { KmRatesSection } from "./sections/KmRatesSection";
import { HotelsSection } from "./sections/HotelsSection";
import { BookingsSection } from "./sections/BookingsSection";
import { TourBookingsSection } from "./sections/TourBookingsSection";
import { PromoCodesSection } from "./sections/PromoCodesSection";
import { PaymentMethodsSection } from "./sections/PaymentMethodsSection";
import { SettingsSection } from "./sections/SettingsSection";
import { EmailSettingsSection } from "./sections/EmailSettingsSection";
import { EmailTemplatesSection } from "./sections/EmailTemplatesSection";
import { HeroSlidesSection } from "./sections/HeroSlidesSection";
import { LandingPagesSection } from "./sections/LandingPagesSection";
import { DestinationsSection } from "./sections/DestinationsSection";
import { ToursSection } from "./sections/ToursSection";
import { SeoSection } from "./sections/SeoSection";
import { TestimonialsSection } from "./sections/TestimonialsSection";

const sectionComponents: Record<AdminSection, React.FC> = {
  airports: AirportsSection,
  zones: ZonesSection,
  service_types: ServiceTypesSection,
  vehicles: VehiclesSection,
  km_rates: KmRatesSection,
  hotels: HotelsSection,
  bookings: BookingsSection,
  tour_bookings: TourBookingsSection,
  promo_codes: PromoCodesSection,
  payment_methods: PaymentMethodsSection,
  email_settings: EmailSettingsSection,
  email_templates: EmailTemplatesSection,
  hero_slides: HeroSlidesSection,
  landing_pages: LandingPagesSection,
  destinations: DestinationsSection,
  tours: ToursSection,
  seo_pages: SeoSection,
  testimonials: TestimonialsSection,
  settings: SettingsSection,
};

export function AdminLayout() {
  const [activeSection, setActiveSection] = useState<AdminSection>("airports");

  const ActiveComponent = sectionComponents[activeSection];
  const activeLabel = menuItems.find((m) => m.key === activeSection)?.label ?? "";

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AdminSidebar activeSection={activeSection} onSectionChange={setActiveSection} />
        <div className="flex-1 flex flex-col">
          <header className="h-14 flex items-center gap-3 border-b bg-card px-4 shrink-0">
            <SidebarTrigger />
            <h1 className="text-lg font-semibold">{activeLabel}</h1>
          </header>
          <main className="flex-1 p-6 overflow-auto bg-muted/30">
            <ActiveComponent />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
